import { css } from '@lastbrand/web-ui-styled-system/css'

// `InputTextField` owns the field chrome + error text; these only cover the wrapper.
// Field styles go through its `css` prop as a `css.raw` object (not `className`).
export const inputOptionWrapperClass = css({
  width: '100%',
})

export const inputFieldCss = css.raw({
  width: '100%',
  textStyle: 'body-14',
  // 40px field height; px literal (no size token). Left padding owned by InputTextField.
  // The `css` prop lands on InputTextField's OUTER column (field + error undertext), so the
  // height must target the bordered field container child — it is hardcoded to 3.25rem (52px)
  // inside the component, visibly taller than the ~40px legacy input (STRFRNT-16344). The
  // undertext sibling carries `data-slot`, the field container does not.
  '& > div:not([data-slot])': {
    height: '40px',
  },
})
